import React, {useCallback, useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper";
import {Helmet} from "react-helmet";
import { useNavigate } from "react-router-dom";
import {input, sip} from "../translate";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Loader from "../components/Loader";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {TableFooter} from "@mui/material";
import {useSelector, useDispatch} from "react-redux";
import Api from "../Api";
import {toast} from "react-toastify";
import { userCrmRequest } from '../store/actions/users';

function CallCenter(props) {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [sip, setSip] = useState([])
    const dispatch = useDispatch()
    const userData = useSelector((state) => state.users.crmData)
    useEffect(() => {
        (async () => {
            await dispatch(userCrmRequest())
        })()
    }, [])
    useEffect(() => {
        (async () => {
            try {
                const {data} = await Api.getCallCenter()
                setSip(data?.sip)
            } catch (e) {
            }
        })()
    }, []);
    const handleOperatorStatus = useCallback(async (buddy,ev) => {
        try {
            const {data} = await Api.callCenterSipUpdate({sip: buddy, redirect_call:ev})
            setSip((prev) => prev.map(p => {
                if (+p.buddy === +buddy) {
                    p.isInstalled = {id: data.crm.id, sip, redirect_call: ev}
                }
                return p
            }))
            toast.success('Success')
        }catch (e) {

        }
    },[])

    const handleSave = useCallback(async (ev) => {
        try {
            const {data} = await Api.callCenterSipCreate({sip: ev})
            setSip((prev) => prev.map(p => {
                if (+p.buddy === +ev) {
                    p.isInstalled = {id: data.crm.id, sip,redirect_call: 0}
                }
                return p
            }))
            toast.success('Success')
        } catch (e) {
            toast.error('Error')
        }
    }, [])

    const handleDelete = useCallback(async (ev, sip) => {
        try {
            await Api.callCenterSipDelete({id: ev})

            toast.success('Success')
            setSip((prev) => prev.map(p => {
                if (+p.buddy === +sip) {
                    p.isInstalled = {}
                }
                return p
            }))
        } catch (e) {
            toast.error('Error')

        }
    }, [])
    return (
        <>
            <Helmet>
                <title>
                    Call-Center
                </title>
            </Helmet>
            <Wrapper>
                {loading ? <div className="loaderContainer"><Loader/></div> :
                    <div className="tableParent" id="tableParent">
                        <Paper sx={{minWidth: 'fit-content', fontSize: 10}}>
                            <TableContainer
                            >
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow className="sip_header">
                                            <TableCell sx={{ fontSize: 20 }} align="left" colSpan={10}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <span>Users of {userData?.callcenter?.domain}</span>
                                                    <Button size="small" variant="outlined" onClick={() => navigate('/short_function/call_center')} sx={{ borderColor: '#7ebc0a', color: '#7ebc0a' }}>
                                                        Settings
                                                    </Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow className="sip_num">
                                            <TableCell align='center'>
                                                SIP
                                            </TableCell>
                                            <TableCell align='center'>
                                                Name
                                            </TableCell>
                                            <TableCell align='center'>
                                                Operator type
                                            </TableCell>
                                            <TableCell
                                                align='center'
                                            >
                                                Action
                                            </TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody id="dataBody">
                                        {sip.length ? sip.map((s, _) => (
                                            <TableRow key={_} hover style={{cursor: 'pointer'}} role="checkbox"
                                                      tabIndex={-1}>
                                                <TableCell align="center">
                                                    {s.buddy}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {s.notes}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {s?.isInstalled?.id ?
                                                        <select
                                                            onChange={(e) => handleOperatorStatus(s.buddy,e.target.value)}
                                                            value={s?.isInstalled?.redirect_call}
                                                            style={{height: 40, border: '1px solid #ccc', outline: 'none'}}>
                                                            <option value="0">Operator</option>
                                                            <option value="1">Awaiting Operator</option>
                                                        </select>:'Not set'}
                                                </TableCell>

                                                <TableCell>
                                                    <div className="d-flex justify-content-center">
                                                        {!s.isInstalled?.id ?
                                                            <button onClick={() => handleSave(s.buddy,)}
                                                                    className="addBtn">
                                                                Save
                                                            </button> : <button
                                                                onClick={() => handleDelete(s.isInstalled.id, s.buddy)}
                                                                className="deleteBtn">
                                                                Delete
                                                            </button>}
                                                    </div>

                                                </TableCell>
                                            </TableRow>

                                        )) : <TableRow hover role="checkbox" tabIndex={-1}>


                                            <TableCell align="center" colSpan={window.innerWidth < 400 ? 6 : 10}>
                                                no data

                                            </TableCell>


                                        </TableRow>
                                        }

                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell align="center" colSpan={window.innerWidth < 400 ? 6 : 10}>
                                                <div style={{margin: 10}} className="crm_save_btn"/>
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </div>}
            </Wrapper>
        </>

    );
}

export default CallCenter;